import { createSelector } from 'reselect'
import { getObjectUtil } from 'packages/src'

function getByIdReduxSelector (domainMapPath, id) {
  return createSelector(
    state => getObjectUtil(state, domainMapPath),
    (domainMap) => {
      return domainMap[id]
    }
  )
}

export default getByIdReduxSelector
